export function replaceLastOccurenceInString(string: string, character: string, replacement: string) {
  const lastIndex = string.lastIndexOf(character);

  return string && character && lastIndex > -1
    ? string.slice(0, lastIndex) + replacement + string.slice(lastIndex + 1)
    : string;
}
